import { Typography } from "antd";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import styles from "./style.module.scss";

export interface TextWithTooltipProps {
  text: string | React.ReactNode;
  maxLines?: number;
  className?: string;
  tooltipPlacement?: "top" | "bottom" | "left" | "right";
  strong?: boolean;
  type?: "default" | "link";
  href?: string;
  onClick?: () => void;
}

export default function TextWithTooltip({
  text,
  maxLines = 1,
  className,
  tooltipPlacement = "top",
  strong = false,
  type = "default",
  href,
  onClick,
}: TextWithTooltipProps) {
  const { Paragraph } = Typography;
  const navigate = useNavigate();

  const ellipsisConfig = {
    rows: maxLines,
    tooltip: text,
    tooltipPlacement: tooltipPlacement,
  };

  const isLink = type === "link";

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (href) {
      navigate(href);
    }
  };

  return (
    <div
      className={classNames(styles.textWrapper, className)}
      data-testid="text-with-tooltip-content"
    >
      <Paragraph
        strong={strong}
        ellipsis={ellipsisConfig}
        className={isLink ? styles.linkText : undefined}
        onClick={isLink ? handleClick : undefined}
      >
        {text}
      </Paragraph>
    </div>
  );
}
